import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { ValueWithLabel } from "@/widgets/value-with-label";
import type { FreightMatching } from "@x-mile/api-contract";

export const CompanyForm = ({
  companies,
  companyId,
}: {
  companies: FreightMatching.schemas.Company[] | null;
  companyId?: number;
}) => {
  if (!companies || !companyId) {
    return null;
  }

  const company = companies.find((company) => company.id === companyId);

  if (!company) {
    return null;
  }

  return (
    <BaseHeaderWrapper title="運送会社情報" maxWidth="628px">
      <BaseKeyValue keyLabel="運送会社">
        <ValueWithLabel label="企業名" value={company.name} emphasis />
      </BaseKeyValue>
    </BaseHeaderWrapper>
  );
};
